import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_sectors = "sectors";
const BASE_URL = "/api/sectors";

const sectorsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const SECTOR_EMPTY = {
    id: '',
    sectorNaam: '',
    sectorNummer: '',
    sectorRekeningNr: '',

    voorzitterNaam: '',
    voorzitterVoornaam: '',
    voorzitterStraat: '',
    voorzitterNr: '',
    voorzitterBus: '',
    voorzitterPostcode: '',
    voorzitterGemeente: '',
    voorzitterTelGsm: '',
    voorzitterEmail: '',

    secretarisNaam: '',
    secretarisVoornaam: '',
    secretarisStraat: '',
    secretarisNr: '',
    secretarisBus: '',
    secretarisPostcode: '',
    secretarisGemeente: '',
    secretarisTelGsm: '',
    secretarisEmail: '',

    extraInfo: '',
    members: []
};

export function useSectors() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_sectors],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...sectorsQueryConfig
    });
    return {...result, sectors: result.data};
}


export function useSector(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_sectors, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...sectorsQueryConfig
    });
    return {...result, sector: result.data};
}

export function useSectorMutations() {
    async function createFunction(sector) {
        if (!sector) return;
        return await fetchPOST(BASE_URL, sector, false);
    }

    async function editFunction(sector) {
        if (!sector) return;
        return await fetchPUT(`${BASE_URL}/${sector.id}`, sector);
    }

    async function deleteFunction(sector) {
        return await fetchDELETE(`${BASE_URL}/${sector.id}`)
    }

    return {
        createSector: useMyMutation(createFunction, REACT_QUERY_ID_sectors, sector => `Sector ${sector.title} created`),
        editSector: useMyMutation(editFunction, REACT_QUERY_ID_sectors, sector => `Sector ${sector.title} modified`),
        deleteSector: useMyMutation(deleteFunction, REACT_QUERY_ID_sectors, sector => `Sector ${sector.title} deleted.`)
    };

}